import { render, staticRenderFns } from "./Reauthorization.vue?vue&type=template&id=48d90afb&scoped=true"
import script from "./Reauthorization.vue?vue&type=script&lang=ts"
export * from "./Reauthorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d90afb",
  null
  
)

export default component.exports